import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=2212b716"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports